import type { AccumUpload } from '@shared/api';

export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export function statusTone(status: string): Tone {
  switch (status) {
    case 'completed':
      return 'success';
    case 'processing':
      return 'info';
    case 'pending':
      return 'warning';
    case 'failed':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'completed':
      return 'готово';
    case 'processing':
      return 'обработка…';
    case 'pending':
      return 'в очереди';
    case 'failed':
      return 'ошибка';
    default:
      return status;
  }
}

/** Прочитать число из summary-JSON загрузки (defensively). */
export function summaryNum(u: AccumUpload, key: string): number | undefined {
  const s = u.summary as Record<string, unknown> | null;
  const v = s?.[key];
  return typeof v === 'number' ? v : undefined;
}

export function summaryMissing(u: AccumUpload): string[] {
  const s = u.summary as Record<string, unknown> | null;
  const v = s?.['rate_missing_codes'];
  return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
}

export function summaryWarnings(u: AccumUpload): string[] {
  const s = u.summary as Record<string, unknown> | null;
  const v = s?.['warnings'];
  return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
}

export function summaryFailedSources(u: AccumUpload): string[] {
  const s = u.summary as Record<string, unknown> | null;
  const v = s?.['failed_sources'];
  return Array.isArray(v)
    ? v
        .filter((x): x is string => typeof x === 'string' && x.trim().length > 0)
        .map((x) => x.trim())
    : [];
}

export function summaryTotalFiles(u: AccumUpload): number {
  return summaryNum(u, 'files') ?? u.file_count;
}

export function kindLabel(kind: string): string {
  return kind === 'seed' ? 'базовая книга' : 'пачка ПА';
}

export const PAGE_SIZE = 50;
